// features/users/useUserMgmt.ts
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppSelector } from "@redux/hooks";
import { parseAxiosError } from "@shared/components/utils/apiErrorParser";


const API_URL = process.env.REACT_APP_API_URL || "";

const tenantQ = (t: number | null | undefined) =>
  t === null || t === undefined ? "" : `?tenantId=${t}`;

export function useUserMgmt() {
  const { getAccessTokenSilently } = useAuth0();
  const { tenantId } = useAppSelector((s) => s.selection);

  async function resetPassword(email: string): Promise<void> {
    try {
      const token = await getAccessTokenSilently();
      const endpoint = `${API_URL}/v1/auth0/users/reset-password${tenantQ(tenantId)}`;
      await axios.post(endpoint, { email }, { headers: { Authorization: `Bearer ${token}` } });
    } catch (e) {
      const { message } = parseAxiosError(e);
      throw new Error(message);
    }
  }

  // later we must add: deleteUser, blockUser, resetMFA, createUser, updateUser, etc.

  return { resetPassword };
}
